/** JSON body for POST /api/admin/products/:id/duplicate (shared with admin UI) */
export interface DuplicateProductOptions {
  copyImage?: boolean;
  copyName?: boolean;
  copySku?: boolean;
  copyPrice?: boolean;
  copySalePrice?: boolean;
  copyCondition?: boolean;
  copyCategory?: boolean;
  copyQuantity?: boolean;
  copySize?: boolean;
  copyBinLocation?: boolean;
}

export type DuplicateFormState = Required<DuplicateProductOptions>;

export function defaultDuplicateFormState(): DuplicateFormState {
  return {
    copyImage: true,
    copyName: false,
    copySku: false,
    copyPrice: false,
    copySalePrice: false,
    copyCondition: false,
    copyCategory: false,
    copyQuantity: false,
    copySize: false,
    copyBinLocation: false,
  };
}
